export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="animate-rise">
        <div className="text-xs font-medium uppercase tracking-wider text-slate-500">{subtitle}</div>
        <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl" data-testid="page-title">{title}</h1>
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}

export function Stat({ label, value, tone = "slate", icon: Icon, testid, hint }) {
  const tones = {
    slate: "text-slate-900",
    sky: "text-red-700",
    green: "text-red-700",
    rose: "text-rose-600",
    amber: "text-amber-600",
  };
  return (
    <div className="card-surface animate-rise p-5" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</span>
        {Icon && <Icon size={18} className="text-slate-400" />}
      </div>
      <div className={`mt-3 font-mono text-2xl font-bold tracking-tight ${tones[tone]}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
}

export function Empty({ text }) {
  return <div className="py-10 text-center text-sm text-slate-500">{text}</div>;
}

export const Page = ({ children }) => <div className="mx-auto max-w-[1400px] p-4 sm:p-6 lg:p-8">{children}</div>;
